// extracted by mini-css-extract-plugin
export default {"latinWrapper":"Latin_latinWrapper__vtbzH","latinText":"Latin_latinText__7DegP","latinList":"Latin_latinList__lLIe+","latinImg":"Latin_latinImg__h4l5y","about":"Latin_about__q5ERz"};